import { redDotClear, redDotInfo } from '../../../api/reddot'

export default {
  // 加载红点数据
  async loadRedDot({ commit }, { items }) {
    const map = await redDotInfo({ items }).then(
      ({ map }) => map,
      () => ({})
    )
    commit('ADD', map)
    return map
  },

  // 清除红点状态
  async clearRedDot(_, { item }) {
    return redDotClear({ item }).then(
      () => true,
      () => false
    )
  }
}
